// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__650CD","overflowing":"ReadFullNote_overflowing__2hnnX"};